import { render, staticRenderFns } from "./FullScreenLoader.vue?vue&type=template&id=f1beb2da&"
import script from "./FullScreenLoader.vue?vue&type=script&lang=js&"
export * from "./FullScreenLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports